<template>
    <div class="col-lg-4 col-md-6 col-sm-12 result mb-4">
        <div class="card">
            <div class="card-body" @click="click()" >
                <div class="row">
                    <div class="col-sm-12 mt-3 text-center">
                        <div class="details row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-4 text-left">
                                        <p class="mb-1 px-2">To:</p>
                                    </div>
                                    <div class="col-8 text-left">
                                        <p class="mb-1 px-2"><strong>{{this.payload.destination_address | truncate(34, '...')}}</strong> </p>
                                    </div>
                                </div>
                                <hr class="my-2">
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-4 text-left">
                                        <p class="mb-1 px-2">From :</p>
                                    </div>
                                    <div class="col-8 text-left">
                                       <p class="mb-1 px-2"><strong>{{this.payload.origin_address | truncate(34, '...')}}</strong> </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <hr class="my-2">
                            </div>
                            <div class="col-12 ">
                                <div class="d-flex justify-content-end align-items-center">
                                    <div class="wrapper">
                                        <a @click="planAgain()"><strong>Plan Again</strong></a>
                                    </div>
                                    <div class="wrapper">
                                        <svg-icon class="ml-2 forward-icon" name="forward"  width="8" height="auto"></svg-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'result-item',
    props: ['payload'],
    components: {

    },
    data() {
        return {
            hash: this.$route.params.hash,

        }
    },
    methods: {
        planAgain() {
            this.$router.push({
                name: 'Home',
                params: {
                    origin: this.payload.origin_address,
                    destination: this.payload.destination_address,
                },
            })
        },
        click() {
            console.log(this.payload.destination_address)
        },
    },
    filters: {
        truncate(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            }
            return text;
        },
    },

}
</script>
